(ns frontend.actions.merge
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->merge [data on-success! on-error!]
  (-> (conn/sendp! :merge/merge
                   data)
      (p/then on-success!)
      (p/catch on-error!)))
